import { type FloatingCardSize } from 'components/FloatingCard';

import { type ColorCodingMap } from '../pointUtils';

export const LEGEND_MIN_SIZE = { width: 220, height: 120 };

export const LEGEND_DEFAULT_WIDTH = 260;

/** Matches `min-height` on legend list rows at scale 1. */
export const LEGEND_ROW_HEIGHT = 28;

/** Vertical padding on the legend list (`1rem` top + `1rem` bottom at scale 1). */
const LEGEND_LIST_PADDING_Y = 32;

/** Floating card header chrome at scale 1 (padding, title, close button). */
const LEGEND_HEADER_HEIGHT = 34;

const LEGEND_MAX_HEIGHT_RATIO = 0.65;

export const getLegendMaxHeight = () => Math.floor(window.innerHeight * LEGEND_MAX_HEIGHT_RATIO);

export const getLegendScale = (width: number) => width / LEGEND_DEFAULT_WIDTH;

export const getLegendContentHeight = (colorCodingMap: ColorCodingMap): number => {
  const visibleItemCount =
    Object.values(colorCodingMap).filter(({ damageCount }) => !!damageCount).length + 1;

  return LEGEND_LIST_PADDING_Y + visibleItemCount * LEGEND_ROW_HEIGHT;
};

export const getLegendInitialSize = (colorCodingMap: ColorCodingMap): FloatingCardSize => {
  const contentHeight = LEGEND_HEADER_HEIGHT + getLegendContentHeight(colorCodingMap);

  return {
    width: LEGEND_DEFAULT_WIDTH,
    height: Math.min(Math.max(LEGEND_MIN_SIZE.height, contentHeight), getLegendMaxHeight()),
  };
};
